<template>
    <button :class="{ like }" @click="toggle(1)" :disabled="readonly" type="button">
        <span class="icon icon-like"></span><span class="text">{{ inner ? likeCount : `推${likeCount}` }}</span>
    </button>
    <div class="block bg:#EBEBEB w:1 h:24 mx:8" v-if="inner"></div>
    <button :class="{ dislike }" @click="toggle(2)" :disabled="readonly" type="button">
        <span class="icon icon-dislike"></span><span class="text">{{ inner ? dislikeCount : `廢${dislikeCount}` }}</span>
    </button>
    <div class="block bg:#EBEBEB w:1 h:24 mx:8" v-if="inner"></div>
    <button :class="{ observe }" @click="toggle(3)" data-bs-custom-class="z:1310!" :disabled="readonly" ref="btnObserve" :title="readonly ? '' : '卡關注'" type="button">
        <span class="icon icon-target"></span><span class="text">{{ inner ? observeCount : `卡${observeCount}` }}</span>
    </button>
</template>

<script setup>
    const btnObserve = ref();

    const props = defineProps({
        collegeId: { type: Number },
        commentId: { type: Number },
        dislike: { required: true, type: Boolean },
        dislikeCount: { required: true, type: Number },
        inner: { default: false, type: Boolean },
        like: { required: true, type: Boolean },
        likeCount: { required: true, type: Number },
        observe: { required: true, type: Boolean },
        observeCount: { required: true, type: Number },
        readonly: { default: false, type: Boolean },
        topicId: { required: true, type: Number }
    });

    const toggle = (type) => {
        const name = { 1: "like", 2: "dislike", 3: "observe" }[type];
        const action = props[name] ? "unlike" : "like";

        api(`api/topic/${action}`, { topic_id: props.topicId, comment_id: props.commentId, type }, { prevent: true }).done((res) => {
            if (res.success) {
                props.likeCount = res.like_count;
                props.dislikeCount = res.dislike_count;
                props.observeCount = res.observe_count;

                if (action === "like") {
                    props[name] = true;

                    switch (type) {
                        case 1:
                            props.dislike = false;
                            break;
                        case 2:
                            props.like = false;
                            break;
                    }
                } else {
                    props[name] = false;
                }
            } else if (res.type === "error") {
                if (res.error === "error.permission-denied") {
                    useGlobal().openCollegeValidator(props.collegeId);
                } else {
                    alert(res.message || res.error);
                }
            }
        });

        switch (type) {
            case 3:
            if (tooltipObserve) {
                tooltipObserve.hide();
            }
            break;
        }
    };

    let tooltipObserve;

    onMounted(() => {
        tooltipObserve = new bootstrap.Tooltip(btnObserve.value);
    });

    onUnmounted(() => {
        if (tooltipObserve) {
            tooltipObserve.dispose();
        }
    });
</script>
